import enUS from './en_us.json';
import ptPT from './pt_pt.json';
import de from './de_de.json';
import es from './es_es.json';
import fr from './fr_fr.json';
import it from './it_it.json';
import nl from './nl_nl.json';
import pl from './pl_pl.json';

export const messages = {
  'en-GB': {}, // Assigned empty object to fallback to generated message
  'en-US': enUS,
  'pt-PT': ptPT,
  de,
  fr,
  es,
  it,
  nl,
  pl,
};
